module.exports = __webpack_public_path__ + "img/header-weddingRingsFrameSettings.fe4ff73.jpg";